import React, { useContext } from 'react'
import { themeGet } from '@styled-system/theme-get'
import { useContentful } from '@pcln/contentful-components'
import styled from 'styled-components'
import { HeroModule } from '@pcln/marketing'
import { Box } from 'pcln-design-system'
import useContent from '@/hooks/useContent'
import SearchForm from '@/components/SearchForm'
import Hero from '@/components/Heros/Hero'
import FreedomImage from '@/images/hero/pcln-hp-hero-freedom.jpg'
import SunsetImage from '@/images/hero/pcln-hp-hero-sunset.png'
import BootstrapDataContext from '@/context/BootstrapDataContext'
import useSeti from '@/hooks/useSeti'
import HomeContent from './HomeContent'

const StyledHero = styled(Hero)`
  img {
    height: 100%;
    object-fit: cover;
    ${themeGet('mediaQueries.xxl')} {
      height: auto;
      width: 100%;
    }
  }
`

const redesignHeroProps = {
  searchForm: <SearchForm isRedesignHero />,
  backgroundImage: {
    url: `${SunsetImage}?opto&auto=webp`,
    altText: 'Woman watching sunset'
  },
  shouldDisplaySilhouette: true
}

export default function HomeDesktop() {
  const { key } = useContext(BootstrapDataContext)
  const heroImageResponse: any = useContentful('heroImage')
  const heroImage = useContent(heroImageResponse)
  const heroProps = {
    img: `${FreedomImage}?opto&auto=webp&crop=2000,800,x200,x400,safe`,
    description: 'Freedom Sale',
    contentfulImage: heroImage
  }
  const isRedesignHero =
    useSeti('HP_HERO_COMPONENT', key === 'home') === 'VARIANT' && key === 'home'
  return isRedesignHero ? (
    <Box style={{ 'overflow-x': 'hidden' }}>
      <Box height="100%" data-testid="hero-outer-box">
        <HeroModule {...redesignHeroProps} />
      </Box>
      <HomeContent isRedesignHero />
    </Box>
  ) : (
    <>
      <StyledHero {...heroProps}>
        <SearchForm />
      </StyledHero>
      <HomeContent />
    </>
  )
}
